import * as React from 'react';
import type {ContextualExpression} from '@packages/utilities/contextual-expression';
import type {CheckerState} from './CheckerState';
import {emptyCheckerState} from './CheckerState';

export const TypeCheckerState = React.createContext<
  [CheckerState, ContextualExpression | null]
>([emptyCheckerState, null]);
